import withRequiredAuth from '../../HOC/withRequiredAuth';
import withRequiredProjects from '../../HOC/withRequiredProjects';
import Bookings from './Bookings';

export default withRequiredProjects(withRequiredAuth(Bookings));
